import * as THREE from "three";

/**
 * The ceiling's hidden layer stack — stenullsisolering, bastufolie, takgles —
 * is owned by the INTERIOR group, so hiding Ytskikt reveals it instead of
 * taking it along with the panel (issue 114/115).
 *
 * But that same stack is also, physically, the underside of the ROOF. With TAK
 * toggled off the user expects to look down into the room, and a full-coverage
 * batt slab hanging in mid-air blocks exactly that view.
 *
 * Two layer flags, one mesh family — the shape `frontVisibility` already
 * solves: the layer group stays the primary owner of the meshes and this
 * named subgroup is a SECOND visibility level inside it. Setting the subgroup
 * to `visibility.roof` while its parent carries `visibility.interior` yields
 * `roof && interior` for free, with no name-sniffing traversal in the viewer
 * and no special case in the UI.
 */
export const CEILING_VISIBILITY_GROUP_NAME =
	"detail/ceiling-visibility/interior";

export function createCeilingVisibilityGroup(parent: THREE.Group): THREE.Group {
	const group = new THREE.Group();
	group.name = CEILING_VISIBILITY_GROUP_NAME;
	parent.add(group);
	return group;
}

/**
 * Looked up rather than handed around as a ref: the interior group is
 * re-created wholesale by selective rebuilds, so a stored reference goes stale
 * the moment the Interior subsystem is dirty. Every apply path already holds
 * the live interior group.
 */
export function getCeilingVisibilityGroup(
	root: THREE.Object3D,
): THREE.Group | null {
	const group = root.getObjectByName(CEILING_VISIBILITY_GROUP_NAME);
	return group instanceof THREE.Group ? group : null;
}
